import Base from './base'
import urls from 'config/urls'

class TestPaper extends Base {
  find (opts) {
    return this.httpGet({
      url: urls.testPaper.find,
      data: opts
    })
  }

  get (opts) {
    return this.httpGet({
      url: urls.testPaper.get,
      data: opts
    })
  }

  create (opts) {
    return this.httpPost({
      url: urls.testPaper.create,
      data: opts
    })
  }

  update (opts) {
    return this.httpPost({
      url: urls.testPaper.update,
      data: opts
    })
  }

  delete (opts) {
    return this.httpPost({
      url: urls.testPaper.delete,
      data: opts
    })
  }

  findQuestion (opts) {
    return this.httpGet({
      url: urls.testPaper.findQuestion,
      data: opts
    })
  }

  addQuestion (opts) {
    return this.httpPost({
      url: urls.testPaper.addQuestion,
      data: opts
    })
  }

  removeQuestion (opts) {
    return this.httpPost({
      url: urls.testPaper.removeQuestion,
      data: opts
    })
  }
}

export default new TestPaper



// WEBPACK FOOTER //
// ./src/models/testPaper.js